import {Component, OnInit} from '@angular/core';
import {InhouseListService} from '../../../../provider/inhouse-list.service';
import {MenuAsideService} from '../../../../core/_base/layout';
import {InhouseListModel} from '../../../models/inhouse-list.model';

@Component({
  selector: 'kt-inhouse-list',
  templateUrl: './inhouse-list.component.html',
  styleUrls: ['./inhouse-list.component.scss']
})
export class InhouseListComponent implements OnInit {

  constructor(
    public inhouseServ: InhouseListService,
    private menuServ: MenuAsideService
  ) {
  }

  ngOnInit() {
    this.menuServ.pathname$.next(window.location.pathname);
    this.inhouseServ.getList();
  }

  async postList(file: File) {
    try {
      await this.inhouseServ.postList(file);
    } catch (err) {
      alert('An error occurred. Please try again!');
      console.log(err);
    }
  }

  async postGuest(data: any) {

    const LISTDATA: InhouseListModel = new InhouseListModel();
    LISTDATA.first_name = data.first_name;
    LISTDATA.last_name = data.last_name;
    LISTDATA.email = data.email;
    LISTDATA.mobile = data.mobile;
    LISTDATA.sex = data.sex;
    LISTDATA.checkin_date = data.checkin_date;
    LISTDATA.check_out_date = data.check_out_date;
    LISTDATA.room_number = data.room_number;
    LISTDATA.nationality = data.nationality;

    this.inhouseServ.postGuest(LISTDATA);
  }
}
